import {Component, ErrorInfo} from "react";
import {Controller} from "./controller/Controller";
import {LogLevel} from "@variocube/app-api";
import {layout, typography, classNames, MessageView, PushButton} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";


interface ErrorBoundaryProps {
    controller: Controller;
}

interface ErrorBoundaryState {
    error?: Error;
    errorInfo?: ErrorInfo;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            error: undefined,
            errorInfo: undefined,
        }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error,
            errorInfo
        });
        this.props.controller.log(LogLevel.Audit, "AppHost", "UI Render error", {error, errorInfo});
    }

    render() {
        if (this.state.error) {
            return (
                <MessageView message="An internal error occurred." className={styles.messageView}>
                    <div className={layout.vertical}>
                        <div>
                            {`${this.state.error}`}
                        </div>
                        <div className={classNames(typography.muted, typography.smaller)}>
                            {this.state.errorInfo?.componentStack}
                        </div>
                        <PushButton primary onClick={this.handleRestart}>
                            Restart
                        </PushButton>
                    </div>
                </MessageView>
            )
        }
        return this.props.children;
    }

    private handleRestart = () => location.reload();
}

const styles = stylesheet({
    messageView: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
    }
})